/**
 * Owner: Haselton Baker Risk Group, LLC
 * Copyright All Rights Reserved
 */
// @flow
import type { Element } from 'react';

import React from 'react';
import classNames from 'classnames';
import SelectMenu from '#components/pages/Models/Model/sections/support/forms/SelectMenu/index.js';

const items = [
  { id: 'none', name: 'None', value: '1' },
  { id: 'slight', name: 'Slight', value: '2' },
  { id: 'moderate', name: 'Moderate', value: '3' },
  { id: 'extreme', name: 'Extreme', value: '4' },
];

type Props = {|
  form: string,
  name: string,
  inputClassName: string,
|};

const StructuralMaterialDeteriorationSelectMenu = ({
  form,
  name,
  inputClassName,
}: Props): Element<typeof SelectMenu> => (
  <SelectMenu
    form={form}
    items={items}
    id={name}
    name={name}
    inputClassName={classNames('custom-select', inputClassName)}
    includeEmptyOption
  />
);

export default StructuralMaterialDeteriorationSelectMenu;
